import { getOrderSummary } from '../../../services/modules/order/order.repository';
import {
  GetOrderSummaryOutput,
  GetOrderSummaryParams,
} from '../../../services/modules/order/order.types';
import { PaginatedEndpointParams } from '../../../services/types';
import { PaginatedResponse } from '../../../types/request.types';
import { OrderListType } from '../../orders/order.types';
import { offlineOrdersRepository } from '../repositories/offlineOrders.repository';
import { OfflineOrderTransformers } from '../transformers/OfflineOrder.transformers';
import { createApiSauceResponse } from '../utils/createApiSauceResponse.util';
import { OfflinePaginatedParamsWithQuery } from './types/common.types';

const calculateSummary: typeof getOrderSummary = async ({
  orderId,
  typedParams,
}: GetOrderSummaryParams) => {
  const order = await offlineOrdersRepository.getById(orderId);

  if (!order) {
    return createApiSauceResponse({
      ok: false,
    });
  }

  const data: GetOrderSummaryOutput = OfflineOrderTransformers.toOrderSummary(order, {
    view: typedParams?.headerType,
    classificationTypeIds: typedParams?.classificationTypeId,
  });

  return createApiSauceResponse({
    ok: true,
    data,
  });
};

const page = async ({ limit, skip, query }: OfflinePaginatedParamsWithQuery) => {
  const offlineOrdersPage = await offlineOrdersRepository.page({ limit, skip, query });

  const offlineOrders = offlineOrdersPage.data;

  const onlineOrders = offlineOrders.map(OfflineOrderTransformers.toOnlineOrder);

  return {
    data: onlineOrders,
    count: offlineOrdersPage.count,
  };
};

const ordersList = async ({
  limit,
  skip,
}: PaginatedEndpointParams): Promise<PaginatedResponse<OrderListType>> => {
  const offlineOrdersPage = await offlineOrdersRepository.page({ limit, skip });
  const offlineOrders = offlineOrdersPage.data;
  const onlineOrders = offlineOrders.map(OfflineOrderTransformers.toOrderListType);
  return {
    data: onlineOrders,
    count: offlineOrdersPage.count,
  };
};

export const orderRepositoryOfflineAdapters = {
  page,
  ordersList,
  calculateSummary,
};
